import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiRegisterService {

  constructor(private http: HttpClient) { }
  registerUser(user){
    this.http.post("http://localhost:3000/register",user).subscribe(res =>{
    })
  }
}
